import { handleActions } from 'redux-actions';
import { setAdditionalServices } from './actions';
const initialState = {};
const additionalServicesReducer = handleActions({
    [setAdditionalServices.toString()]: (_, { payload }) => payload
}, initialState);
export default additionalServicesReducer;
